// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mr_EP","tabsBox":"styles_tabsBox__2SkoI","createButton":"styles_createButton__2SckO"};